<div class="row">
  <div class="column" style="text-align: center">
    <div *ngIf="LabState === 'NJ'">Bergen County Sheriff's Dept.</div>
    <div *ngIf="LabState === 'NJ'">Camden County Sheriff's Dept.</div>
    <div *ngIf="LabState === 'NJ'">Essex County Sheriff's Dept.</div>
    <div *ngIf="LabState === 'NJ'">Newark Police Dept.</div>
    <div *ngIf="LabState === 'NJ'">New Jersey State Police</div>
    <div *ngIf="LabState !== 'NJ'">&nbsp;</div>
  </div>
  <div class="column2" style="text-align: center">
    <img *ngIf="LabImg && LabImg != '' " [src]="'data:image/png;base64,'+LabImg"  height="150" width="150" alt=""/>
  </div>
  <div class="column" style="text-align: center">
    <div *ngIf="LabState === 'NJ'">Ocean County Sheriff's Dept.</div>
    <div *ngIf="LabState === 'NJ'">Paterson Police Dept.</div>
    <div *ngIf="LabState === 'NJ'">Union County Police Dept.</div>
    <div *ngIf="LabState === 'NJ'">Bureau of Alcohol, Tobacco & Firearms</div>
    <div *ngIf="LabState !== 'NJ'">&nbsp;</div>
  </div>
</div>

<div style="margin-top: 5px">
  <h3 class="NIBIN_subheader">{{fullLabName?.toUpperCase()}}</h3>
  <h3 class="NIBIN_subheader">Statewide Standard NIBIN Information Alert</h3>
  <h3 class="NIBIN_subheader">NATIONAL INTEGRATED BALLISTIC INFORMATION NETWORK (NIBIN)</h3>
</div>

<mat-radio-group [(ngModel)]="ReportInfo.NIBINHit" [disabled]="!isEditable">
  <div style="margin:5px;">
    <mat-radio-button [value]="true"></mat-radio-button>
    <span style="font-weight: bold">NIBIN Hit:</span> Through microscopic examination, evidence from the below listed cases has resulted in an identification.
  </div>

  <div style="margin:5px;">
    <mat-radio-button [value]="false"></mat-radio-button>
    <span style="font-weight: bold">Potential NIBIN Hit:</span> NIBIN has produced an unconfirmed correlation (HIT). This should only be considered an investigative lead. A
    microscopic examination by a firearms examiner is needed to confirm this association. If confirmation is necessary to further the listed
    investigations, return your evidence to the ballistics lab of submission. A microscopic confirmation will not be conducted unless specifically
    requested by the submitting agency. Please contact the ballistics lab of submission. <span style="color: red">NOT PROBABLE CAUSE.</span>
  </div>

</mat-radio-group>

<div>
  To request DNA analysis, please contact the ballistics unit of submission for further details.
</div>

<hr>

<table style="width: 100%;">
  <thead>
    <tr style="font-weight: bold">
      <td>Lab #</td>
      <td>Agency/Case Number</td>
      <td>Date of Occurrence</td>
      <td>Date of Submission</td>
      <td>Incident Type</td>
      <td>Case Event Type</td>
      <td>Location</td>
      <td>County</td>
      <td style="width: 50px" *ngIf="showDelete"></td>
    </tr>
  </thead>
  <tbody>
  <ng-container *ngIf="incidents">
    <tr *ngFor="let incident of incidents" [style]="incident.SelectedAsPrimary && ReportGunRecoveredType()? 'background-color:#F8E473;':incident.SelectedAsPrimary?'background-color:#ECEBEA;':''">
      <td>
        <mat-checkbox *ngIf="isEditable" [(ngModel)]="incident.SelectedAsPrimary" [disabled]="isIncidentPrimaryCheckboxDisabled(incident)" ></mat-checkbox>

        <button mat-button (click)="DownloadPDFSIncidentID(incident)">
          <span style="font-weight: normal;">{{incident.LabNumber}}</span>
        </button>

      </td>
      <td> {{incident.Dept}} / {{incident.CaseNumber}}</td>
      <td> {{incident.OccurrenceDate | date:'MM-dd-yyyy' }}</td>
      <td>
        <!--      {{incident.SubmissionDate | date:'MM-dd-yyyy'}}-->
        {{getIncidentDateOfSubmission(incident) | date:'MM-dd-yyyy'}}
      </td>
      <td> {{incident.Inc_Type}}</td>
      <td> {{incident.Inc_RelatedArea}}</td>
      <td> {{incident.Inc_Location}} <br />{{incident.Inc_City}} {{incident.Inc_State}}</td>
      <td> {{incident.County}}</td>
      <td  *ngIf="showDelete">
        <button class="small-icon-button" mat-icon-button color="warn" (click)="removeIncident.emit(incident)"><mat-icon>delete</mat-icon></button>
        <button class="small-icon-button" mat-icon-button (click)="editIncidentDialog(incident)" *ngIf="(this.user.CurrentDept.toLowerCase()==incident.Lab?.toLowerCase() || this.user?.OTHER_DEPTS?.includes(incident.Lab ? incident.Lab.toLowerCase() :''))"><mat-icon>edit</mat-icon></button>
      </td>

    </tr>
  </ng-container>
  </tbody>
</table>

<hr>

<div>
  <span style="font-weight: bold">Additional Information:</span> (Further explain the relations, including case numbers, caliber(s) of weapon(s) involved, and names of victims and suspects.)
  <span *ngIf="isEditable">  <hr /> <mat-checkbox [(ngModel)]="ReportInfo.showAllWeaponsFlag">SHOW ALL RECOVERED FIREARMS</mat-checkbox> <hr /></span>
</div>

<table style="width: 100%;">
  <tbody>
  <ng-container *ngIf="incidents">
    <tr *ngFor="let incident of incidents">
      <td>
        <button mat-button (click)="DownloadPDFSIncidentID(incident)">
          <span style="font-weight: normal;">{{incident.LabNumber}}</span>
        </button>
      </td>
      <td>

        <table style="width: 100%;">
          <tbody>
          <ng-container *ngIf="incident.RPT_AdditionalInfoEvidence" >
            <ng-container *ngFor="let evidence of incident.RPT_AdditionalInfoEvidence">
              <tr *ngIf="!isEvidenceSuppressed(incident,evidence, ReportInfo.showAllWeaponsFlag)" [style]="evidence.SelectedForAssoc? ReportGunRecoveredType() ? 'background-color:#F8E473;': 'background-color:#ECEBEA;':''">
                <td style="width: 100px" >
                  EVIDENCE
                  <div *ngIf="isEditable && isEvidenceAssocTypeDisabled(incident,evidence)">
                    <mat-form-field  style=" padding: 3px;">
                      <mat-label>Association Type:</mat-label>
                      <mat-select [(value)]="evidence.Assoc_Type">
                        <mat-option  value="POTENTIAL">
                          POTENTIAL
                        </mat-option>
                        <mat-option  value="CONFIRMED">
                          CONFIRMED
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div *ngIf="!isEditable">
                    <br /> <span style="font-weight: bold">{{evidence.Assoc_Type}}</span>
                  </div>
                </td>
                <td *ngIf="isEditable">
                  <mat-checkbox [(ngModel)]="evidence.SelectedForAssoc" (change)="TriggerCheckForOtherAssociatedIncidents(evidence.SelectedForAssoc,evidence.EV_ID, evidence.EV_Type)" [disabled]="isEvidenceCheckboxDisabled(incident,evidence)"></mat-checkbox>
                </td>
                <td [style]="(evidence.SelectedForAssoc)? 'font-weight:bold':''">
                  <pre style="font-family: sans-serif;">{{evidence.EV_Text}}</pre>
                </td>
              </tr>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="incident.Persons">
            <tr *ngFor="let person of incident.Persons">
              <td style="width: 100px">
                {{person.Role}}
              </td>
              <td *ngIf="isEditable" style="width: 5px">

              </td>
              <td>
                {{person.Rank}} {{ person.FIRSTNAME }} {{person.MI}} {{person.LASTNAME}} {{person.Suffix}} <span *ngIf="person.DOB"> [ DOB: {{person.DOB.split('T')[0]}} ]</span>
              </td>
            </tr>
          </ng-container>

          <tr *ngIf="incident.Notes && incident.Notes.trim().length>0">
            <td  style="width: 100px"> CASE NOTES</td>
            <td colspan="2">
              {{incident.Notes}}
            </td>
          </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </ng-container>
  </tbody>
</table>

<hr>

<table style="width: 100%; text-align: center;">
  <tr style="font-weight: bold;" *ngIf="!isEditable">
    <td>{{ReportInfo.ReferenceNumber}}</td>
    <td>{{ReportInfo.Examiner}}</td>
    <td>{{ReportInfo.EnteredDateTime | date:'MM-dd-yyyy'}}</td>
    <td>{{ReportInfo.Reviewer}}</td>
  </tr>
  <tr style="font-weight: bold;" *ngIf="isEditable">
    <td><mat-form-field appearance="outline" ><input matInput [(ngModel)]="ReportInfo.ReferenceNumber"></mat-form-field></td>
    <td><mat-form-field appearance="outline"><input matInput [(ngModel)]="ReportInfo.Examiner"></mat-form-field></td>
    <td>
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="EnteredDateTime" [(ngModel)]="ReportInfo.EnteredDateTime" name="DTOFOCC">
        <mat-datepicker-toggle matSuffix [for]="EnteredDateTime"></mat-datepicker-toggle>
        <mat-datepicker #EnteredDateTime></mat-datepicker>
      </mat-form-field>
    </td>
    <td><mat-form-field appearance="outline"><input matInput [(ngModel)]="ReportInfo.Reviewer"></mat-form-field></td>
  </tr>

  <tr style="font-style: italic; color:darkgray;">
    <td>Hit/Reference No.</td>
    <td>Examiner</td>
    <td>Date</td>
    <td>Reviewer</td>
  </tr>
</table>


<div style="color: red" *ngIf="LabState === 'NJ'">
  <span style="font-weight: bold; font-size: 8pt;">As required by PL 2013 Ch. 162: </span>
  <span style="font-size: 8pt;"> Whenever a law enforcement agency seizes or recovers a firearm that was unlawfully possessed, used for any unlawful purpose, recovered from the scene
  of a Crime, is reasonably believed to have been used or associated with the commission of a crime, or is acquired by the agency as an abandoned or discarded firearm, the agency shall arrange for every such
  firearm that in accordance with protocols promulgated by the Attorney General and superintendent is determined to meant and be suitable for National Integrated Ballistics Identification Network data entry and
  examination to be test fired as soon as may be practicable and the results of that test firing be forthwith submitted to the National Integrated Ballistics Identification Network to determine whether the firearm is
  associated or related to a crime, criminal event, or any individual associated or related to a crime or criminal event or reasonably believed to be associated or related to a crime or criminal event. Whenever a
  law enforcement agency recovers any spent shell casing at a crime scene or has reason to believe that the recovered spent shell casing is related to or associated with the commission of a crime or the
    unlawful discharge of a firearm, the agency shall, as soon as may be practicable, submit the ballistics information to the National Integrated Ballistics Identification Network.</span>
</div>

<div style="color: black; background: lightgray; width: 100%">
  <span style="font-weight: bold; font-size: 8pt;">(U) INFORMATION NOTICE:</span>
  <span style="font-size: 8pt;"> This product contains unclassified information that is law enforcement sensitive (LES) and for
  official use only (U//FOUO). Recipients should not release any portion of this product to the media, public, or other personnel
  who do not have a valid need-to-know.</span>
</div>

